import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup, Label, Input, InputGroup, InputGroupAddon, Button
} from 'reactstrap';

import CardContactosEmergencia from "components/Varios/CardContactosEmergencia.js";
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import { alertService } from 'components/Varios/alert_service.js';

import { authenticationService } from '../services/authentication.service';
import { tiposIdentificacion } from './InformacionFamiliar';
import { mensajeCamposIncompletos } from './constants';
import { ID_PAIS_ECUADOR } from './Telefonos';

const id = 1043
const API_URL = configData.SERVER_URL
const tiposTelefono = [
    { label: 'Domicilio', value: "D" },
    { label: 'Trabajo', value: "T" },
    { label: 'Celular', value: "C" },
    // { label: 'Otro', value: "O" },

];

var codigosTelefonicos = {}

export class ContactosEmergenciaData {
    idcontactopersona: number = 0;
    idpersona: number = 0;
    nombrecontacto: string = "";
    direccioncontacto: string = "";
    telefonocontacto: string = "";
    idparentescocontac: number = 0;
    codigopais: string = "593";
    idpais: number = 1;
    idprovincia: number = 0;
    idcanton: number = 0;
    strNombreParentesco: string = "";
    strNombrePais: string = "";
    strNombreProvincia: string = "";
    strNombreCanton: string = "";
    tipotelefono: string = "D";
    codigoarea: string = "";
    codigopostal: string = "";
    email: string = "";
    tipoidentificacion: string = "CED";
    numeroidentificacion: string = "";
    nombres: string = "";
    apellidos: string = "";

}

interface ContactosEmergenciaDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: ContactosEmergenciaData;
    ContactosEmergenciaDataList: ContactosEmergenciaData[];
    tiposTelefonoList: Array<any>;
    paisList: Array<any>;
    provinciaList: Array<any>;
    ciudadList: Array<any>;
    parentescoList: Array<any>;
    codigosPaisList: Array<any>;
    codigoAreaList: Array<any>;
    error: null,
    readOnlyCodigoProvincia,
    readOnlyDatos: boolean;

}

export async function buscarPersona(NumeroIdentificacion: string, InformacionContactosEmergenciaState: ContactosEmergenciaData) {
    const numeroidentificacion = NumeroIdentificacion;

    const { tipoidentificacion } = InformacionContactosEmergenciaState;


    // const auxiliarGetNombresCompletos = (nombre_padre: string, nombre_madre: string, nombre: string) => {
    //     var nombres = "";
    //     var apellido_padre = "";
    //     var apellido_madre = "";

    //     var padre_list = nombre_padre.trim().split(' ');
    //     var madre_list = nombre_madre.trim().split(' ');
    //     var nombres_list = nombre.trim().split(' ');

    //     var herencia_padre_tmp = padre_list.filter(x => nombres_list.includes(x.toString()));
    //     var herencia_madre_tmp = madre_list.filter(x => nombres_list.includes(x.toString()));

    //     var herencia_padre_array = herencia_padre_tmp;
    //     var herencia_madre_array = herencia_madre_tmp;

    //     var herencia_padre: any[] = [];
    //     var herencia_madre: any[] = [];

    //     //Obtenemos el primer apellido
    //     var primer_apellido = "";
    //     if (herencia_padre_array.length > 0) {
    //         primer_apellido = padre_list[0];
    //     }
    //     else {
    //         primer_apellido = madre_list[0];
    //     }

    //     //APELLIDOS NOMBRES
    //     if (nombre.indexOf(primer_apellido) === 0) {
    //         var i_tmp = 0;
    //         //Limpiamos la herencia del padre
    //         herencia_padre = [];
    //         i_tmp = 0;
    //         for (let i = 0; i < herencia_padre_array.length; i++) {
    //             if (padre_list.indexOf(herencia_padre_array[i]) === i_tmp) {
    //                 herencia_padre.push(herencia_padre_array[i]);
    //                 i_tmp++;
    //             }
    //         }

    //         //Limpiamos la herencia del madre
    //         var i_tmp = 0;
    //         herencia_madre = [];
    //         i_tmp = 0;
    //         for (let i = 0; i < herencia_madre_array.length; i++) {
    //             if (madre_list.indexOf(herencia_madre_array[i]) === i_tmp) {
    //                 herencia_madre.push(herencia_madre_array[i]);
    //                 i_tmp++;
    //             }
    //         }
    //     }
    //     else {
    //         //Limpiamos la herencia del padre
    //         herencia_padre = [];
    //         var pos_ap = 0;
    //         for (let i = 0; i < herencia_padre_array.length; i++) {
    //             if (nombres_list.indexOf(herencia_padre_array[i]) === pos_ap) {
    //                 herencia_padre.push(herencia_padre_array[i]);
    //                 pos_ap++;
    //             }
    //         }

    //         //Limpiamos la herencia del madre
    //         herencia_madre = [];
    //         for (let i = 0; i < herencia_madre_array.length; i++) {
    //             if (nombres_list.indexOf(herencia_madre_array[i]) === pos_ap) {
    //                 herencia_madre.push(herencia_madre_array[i]);
    //                 pos_ap++;
    //             }
    //         }

    //     }

    //     herencia_padre.forEach(i_padre => {
    //         apellido_padre += i_padre + " ";
    //     }
    //     );

    //     apellido_padre = apellido_padre.trim();

    //     //Obtenemos el apellido de la madre
    //     herencia_madre.forEach(i_madre => {
    //         apellido_madre += i_madre + " ";
    //     }
    //     );

    //     apellido_madre = apellido_madre.trim();

    //     try {
    //         // if (apellido_padre != "") {
    //         //     nombres = nombre.trim().replace(apellido_padre, "");
    //         // }
    //         // else {
    //         //     nombres = nombre;
    //         // }

    //         // if (apellido_madre != "") {
    //         //     nombres = nombres.replace(apellido_madre, "");
    //         // }
    //         // nombres = nombres.trim();
    //         if (apellido_padre != "") {
    //             apellido_padre.split(" ").forEach(word => {
    //                 nombres = nombres.replace(word, "").trim();
    //             });
    //         }
            
    //         if (apellido_madre != "") {
    //             apellido_madre.split(" ").forEach(word => {
    //                 nombres = nombres.replace(word, "").trim();
    //             });
    //         }
            
    //     }
    //     catch
    //     {
    //         nombres = "";
    //         apellido_padre = "";
    //         apellido_madre = "";
    //     }

    //     return {
    //         nombre: nombres,
    //         apellido: apellido_padre,
    //         apellido2: apellido_madre
    //     };


    // }

    const auxiliarGetNombresCompletos = (
        nombre_padre: string, 
        nombre_madre: string, 
        nombre: string
    ) => {
        let nombres = nombre.trim();
        let apellido_padre = "";
        let apellido_madre = "";
    
        const padre_list = nombre_padre.trim().split(" ");
        const madre_list = nombre_madre.trim().split(" ");
        let nombres_list = nombres.trim().split(" ");
    
        // Tomamos solo el primer apellido del padre y madre
        apellido_padre = padre_list[0] || ""; 
        apellido_madre = madre_list[0] || "";
    
        // Filtramos el nombre, quitando solo los apellidos principales
        nombres_list = nombres_list.filter(word => word !== apellido_padre && word !== apellido_madre);
    
        return {
            nombre: nombres_list.join(" ").trim(), // Devolvemos solo lo que no es apellido
            apellido: apellido_padre.trim(),
            apellido2: apellido_madre.trim()
        };
    };
    var newInformacionContactosEmergencia: ContactosEmergenciaData = { ...InformacionContactosEmergenciaState };

    var informacionDeseada: ContactosEmergenciaData | undefined = newInformacionContactosEmergencia;
    var readOnlyDatos: boolean = false;


    if (tipoidentificacion === "CED" && numeroidentificacion && numeroidentificacion.length === 10) {
        await fetch(API_URL + "DatosGenerales/Ciudadano/" + numeroidentificacion)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        if (result.entTabla[0].nombre) {
                            if (result.entTabla[0].nombrePadre && result.entTabla[0].nombreMadre && result.entTabla[0].nombre) {
                                const { nombre, apellido, apellido2 } = auxiliarGetNombresCompletos(result.entTabla[0].nombrePadre, result.entTabla[0].nombreMadre, result.entTabla[0].nombre);
                                newInformacionContactosEmergencia.nombres = nombre;
                                newInformacionContactosEmergencia.apellidos = `${apellido} ${apellido2}`;
                                newInformacionContactosEmergencia.numeroidentificacion = numeroidentificacion;
                            }
                            informacionDeseada = newInformacionContactosEmergencia;
                            readOnlyDatos = true;
                        }
                    } else {
                        alertService.error("Ocurrió un error al obtener información del ciudadano.")
                    }
                },
                (error) => {
                    alertService.error("Ocurrió un error: " + error)
                    informacionDeseada = undefined;
                    readOnlyDatos = true;
                }
            )
    }

    return {
        informacionDeseada,
        readOnlyDatos
    }


}


export class Telefonos extends React.Component<RouteComponentProps<{}>, ContactosEmergenciaDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true,
            dtoData: new ContactosEmergenciaData(), tiposTelefonoList: [], paisList: [], provinciaList: [], ciudadList: [],
            parentescoList: [], codigosPaisList: [], codigoAreaList: [], ContactosEmergenciaDataList: [], error: null,
            readOnlyCodigoProvincia: false, readOnlyDatos: false
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarProvincias = this.cargarProvincias.bind(this);
        this.cargarCantones = this.cargarCantones.bind(this);
        this.cargarContactos = this.cargarContactos.bind(this);
        //this.cargarCodigoArea = this.cargarCodigoArea.bind(this);
        this.handleSelectChangeTipo = this.handleSelectChangeTipo.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.chooseNameCard = this.chooseNameCard.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarContactos();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {

        this.setState({
            tiposTelefonoList: tiposTelefono,
        });

        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            paisList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nombre
                            })),
                            loading: false
                        });

                        var paises = []
                        for (var i = 0; i < result.entTabla.length; i++) {
                            codigosTelefonicos[result.entTabla[i].idpais] = (result.entTabla[i].codigotelefonico ? result.entTabla[i].codigotelefonico.trim() : "");
                        }

                        this.cargarProvincias(1, false);

                        //this.setState({
                        //    loading: false,
                        //    codigosPaisList: paises
                        //});

                    } else if (result.strEstado === "N") {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los países.")
                    }
                    else {
                        alertService.error("Ocurrió un error: " + result)
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        paisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER PARENTESCO
        fetch(API_URL + "DatosContactoEmergencia/ContactoEmergenciaParentesco")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            parentescoList: result.entTabla.map(d => ({
                                "value": d.idparentesco,
                                "label": d.nombre
                            })),
                            loading: false
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los parentescos.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        parentescoList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarProvincias(idPais, change = true) {
        var dto = this.state.dtoData;
        var ciudadList = this.state.ciudadList;
        dto["idpais"] = idPais;
        if (change) {
            dto["idprovincia"] = 0;
            dto["idcanton"] = 0;
            dto["codigopais"] = codigosTelefonicos[idPais];
            ciudadList = []
        }

        if (dto.idpais === 1 && dto.tipotelefono === "C") {
            dto.codigoarea = "09"
        }

        this.setState({
            dtoData: dto,
            ciudadList: ciudadList
        });

        fetch(API_URL + "DatosGenerales/ProvinciaIdPais/" + idPais)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            provinciaList: result.entTabla.map(d => ({
                                "value": d.idprovincia,
                                "label": d.nombre
                            })),
                            loading: false
                        });

                        if (dto.idpais === 1) {
                            var provincias: any[] = []
                            var codigosRepetidos: any = {}
                            for (var i = 0; i < result.entTabla.length; i++) {
                                if (result.entTabla[i].codigotelefono) {
                                    if (Object.keys(codigosRepetidos).includes(result.entTabla[i].codigotelefono)) {
                                        codigosRepetidos[result.entTabla[i].codigotelefono] = codigosRepetidos[result.entTabla[i].codigotelefono] + "/" + result.entTabla[i].nombre
                                    }
                                    else {
                                        codigosRepetidos[result.entTabla[i].codigotelefono] = result.entTabla[i].nombre
                                    }
                                }
                            }

                            for (let i in codigosRepetidos) {
                                provincias.push({
                                    "value": i,
                                    "label": codigosRepetidos[i] + " - " + i
                                })
                            }

                            this.setState({
                                loading: false,
                                codigoAreaList: provincias,
                                readOnlyCodigoProvincia: true
                            });
                        }
                        else {
                            this.setState({
                                readOnlyCodigoProvincia: false
                            });
                        }

                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las provincias.")
                    }
                },

                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        provinciaList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarCantones(idProvincia, change = true) {
        var dto = this.state.dtoData;
        dto["idprovincia"] = idProvincia;
        if (change) {
            dto["idcanton"] = 0;
        }

        this.setState({
            dtoData: dto,
        });

        fetch(API_URL + "DatosGenerales/CantonIdProvincia/" + idProvincia)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            ciudadList: result.entTabla.map(d => ({
                                "value": d.idcanton,
                                "label": d.nombre
                            })),
                            loading: false
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los cantones.")
                    }
                },

                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        ciudadList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarContactos() {
        fetch(API_URL + "DatosContactoEmergencia/ContactoEmergenciaByIdPersonaDesc/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        //console.log(result.entTabla)
                        this.setState({
                            ContactosEmergenciaDataList: result.entTabla,
                            loading: false,
                            loadingList: false
                        });
                    } else {
                        this.setState({
                            loadingList: false
                        });
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los contactos de emergencia.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        ContactosEmergenciaDataList: []
                    });
                    alertService.error("Ocurrió un error.")
                }
            )
    }

    async auxiliarHandleTipoIdentificacion(valorNumeroIdent: string) {

        const { tipoidentificacion } = this.state.dtoData;
        const numeroidentificacion = valorNumeroIdent.substring(0, 10);


        if (tipoidentificacion === "CED" && numeroidentificacion && numeroidentificacion.length === 10) {

            this.setState({
                dtoData: { ...this.state.dtoData, numeroidentificacion, nombres: "Cargando...", apellidos: "Cargando..." }
            })

            const { informacionDeseada, readOnlyDatos } = await buscarPersona(numeroidentificacion, this.state.dtoData);
            this.setState({ readOnlyDatos: readOnlyDatos, dtoData: informacionDeseada })
        }

        else {
            this.setState({
                dtoData: { ...this.state.dtoData, numeroidentificacion, nombres: "", apellidos: "" },
                readOnlyDatos: false
            });
        }

    }

    handleSelectChange(value, name, tipo = null) {
        const { numeroidentificacion } = this.state.dtoData;
        if (name === "tipoidentificacion" && value === "PAS") {
            var NuevaInformacionContactosEmergencia: ContactosEmergenciaData = {
                ...this.state.dtoData,
                nombres: "",
                apellidos: "",
                tipoidentificacion: value
            }
            this.setState({
                dtoData: NuevaInformacionContactosEmergencia,
                readOnlyDatos: false
            });
        }
        else if (name === "tipoidentificacion" && value === "CED" && numeroidentificacion && numeroidentificacion.length === 10) {

            this.auxiliarHandleTipoIdentificacion(numeroidentificacion);

        }
        else {
            var dto = this.state.dtoData;
            dto[name] = value;
            this.setState({ dtoData: dto });
        }


    }

    handleChange(event) {
        var dto = this.state.dtoData;

        if (event.target.name === "numeroidentificacion") {
            this.auxiliarHandleTipoIdentificacion(event.target.value)
        }
        else {
            dto[event.target.name] = event.target.value;
            this.setState({
                dtoData: dto,
                loading: false
            })
        }

    }

    handleSelectChangeTipo(tipo) {
        var dto = this.state.dtoData;
        dto["tipotelefono"] = tipo;
        var rocp;
        if (tipo === "C" && dto.codigopais === "593") {
            var dto = this.state.dtoData;
            dto["codigoarea"] = "09";
            rocp = true;
        }
        else if (dto.codigopais !== "593") {
            rocp = false;
        }
        this.setState({
            dtoData: dto,
            readOnlyCodigoProvincia: rocp
        });

    }

    onClickEdit(idcontactopersona) {
        //API PARA OBTENER TELEFONOS DE PERSONA
        fetch(API_URL + "DatosContactoEmergencia/ContactoEmergenciaById/" + idcontactopersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        var dto:ContactosEmergenciaData = result.entTabla[0]

                        dto.telefonocontacto = result.entTabla[0].telefonocontacto ? result.entTabla[0].telefonocontacto.trim() : "";
                        dto.email = result.entTabla[0].email ? result.entTabla[0].email.trim() : "";
                        dto.codigoarea = result.entTabla[0].codigoarea ? result.entTabla[0].codigoarea.trim() : "";
                        if(dto.nombrecontacto && dto.nombrecontacto !== "" && !dto.numeroidentificacion){
                            dto.tipoidentificacion = "CED"
                            dto.nombres = ""
                            dto.apellidos = ""
                            dto.numeroidentificacion = ""
                        }
                        
                        

                        this.setState({
                            dtoData: dto,
                            loading: false
                        });

                        if (result.entTabla[0]["idpais"]) {
                            this.cargarProvincias(result.entTabla[0]["idpais"], false)
                            if (result.entTabla[0]["idprovincia"]) {
                                this.cargarCantones(result.entTabla[0]["idprovincia"], false)
                            }

                        }

                        var roca = false;
                        if (result.entTabla[0]["codigopais"] === "593" && result.entTabla[0]["tipotelefono"] === "C") {
                            roca = true
                        }

                        this.setState({
                            readOnlyCodigoProvincia: roca
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        dtoData: new ContactosEmergenciaData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idcontactopersona) {
        //API PARA OBTENER TELEFONOS DE PERSONA
        fetch(API_URL + "FormularioController/DeleteDatosContactoEmergencia/" + idcontactopersona, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("El contacto de emergencia se eliminó correctamente.")
                        authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                        this.cargarContactos();
                    }

                    this.props.history.push("/admin/contactos-de-emergencia");
                })
    }

    onClickLimpiar() {
        this.setState({ dtoData: new ContactosEmergenciaData() });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var dto = this.state.dtoData;
        dto[name] = value;

        this.setState({ dtoData: dto });
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        let formIsValid = true;


        if (dto["codigopais"].length > 3) {
            alertService.error("Ocurrió un error: El código país debe contener máximo 3 dígitos.")
            return;
        }

        if (dto["codigoarea"].length > 2) {
            alertService.error("Ocurrió un error: El código área debe contener máximo 2 dígitos.")
            return;
        }

        if (dto["telefonocontacto"].trim().length > 8) {
            alertService.error("Ocurrió un error: El número de teléfono debe contener máximo 8 dígitos.")
            return;
        }

        if (dto["codigopais"] === "593") {
            if (dto["tipotelefono"] === "D") {
                if (dto["telefonocontacto"].trim().length !== 7) {
                    alertService.error("Ocurrió un error: El número de teléfono debe contener 7 dígitos.")
                    return;
                }
            }
            else if (dto["tipotelefono"] === "C") {
                if (dto["telefonocontacto"].trim().length !== 8) {
                    alertService.error("Ocurrió un error: El número de teléfono debe contener 8 dígitos.")
                    return;
                }
            }
            else {
                if (dto["telefonocontacto"].length !== 7 && dto["telefonocontacto"].length !== 8) {
                    alertService.error("Ocurrió un error: El número de teléfono debe contener de 7 a 8 dígitos.")
                    return;
                }
            }
        }

        const NoObligatorios = ["evidencias", "codigopostal", "email"]

        forma.forEach((value, clave) => {

            if (!value && (!NoObligatorios.find((campo) => campo === clave))) {
                formIsValid = false;
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (clave === "telefonocontacto") {
                dto[clave] = String(value).trim();
            }

        });

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "tcontactopersona": dto
        });

        if (formIsValid) {
            if (dto.idcontactopersona === 0) {
                fetch(API_URL + "FormularioController/PostDatosContactoEmergencia", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(mensajeCamposIncompletos())

                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("El contacto de emergencia se ha actualizado correctamente.")
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())
                                this.cargarContactos();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error(responseJson)
                            }

                        },
                        (error) => {
                            alertService.error(error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosContactoEmergencia", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            //console.log(responseJson)
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])

                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("El contacto de emergencia se ha registrado correctamente.")
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())
                                this.cargarContactos();
                                this.onClickLimpiar()
                            }
                            else {
                                //console.log(responseJson)
                                alertService.error(responseJson)
                            }

                        },
                        (error) => {
                            alertService.error(error)
                        })
            }
        } else {
            alertService.error(mensajeCamposIncompletos());
        }
    }


    private handleCancel(e) {

        e.preventDefault();

        this.props.history.push("/fetch-contactos");

    }

    chooseNameCard(informacionContacto:ContactosEmergenciaData){
        if( (informacionContacto.numeroidentificacion )&& (informacionContacto.nombrecontacto || informacionContacto.nombres || informacionContacto.apellidos)){
            return (informacionContacto.nombres + " " + informacionContacto.apellidos)
        }
        else if (!informacionContacto.numeroidentificacion && informacionContacto.nombrecontacto){
            return (informacionContacto.nombrecontacto)
        }
        
        
    }



    lengthValidation(event, maxLength,codigoArea:boolean) {
        var dto = this.state.dtoData;
        if (dto.idpais === ID_PAIS_ECUADOR && codigoArea) {
            dto[event.target.name] = event.target.value.substring(0, 2);
        }
        else{
            dto[event.target.name] = event.target.value.substring(0, maxLength);
        }
        
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    public render() {

        let contents = this.state.loading

            ?
            <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.paisList, this.state.provinciaList, this.state.ciudadList, this.state.parentescoList, this.state.ContactosEmergenciaDataList, this.state.tiposTelefonoList, this.state.codigosPaisList, this.state.codigoAreaList);

        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(paisList: Array<any>, provinciaList: Array<any>, ciudadList: Array<any>, parentescoList: Array<any>, ContactosEmergenciaDataList: ContactosEmergenciaData[], tiposTelefonoList, codigosPaisList: Array<any>, codigoAreaList: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">CONTACTOS DE EMERGENCIA</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave} id="formTelefonos">
                                        <Row form>
                                            <Col md={2} sm={12} xs={12}>
                                                <FormGroup>
                                                    <Label for="tipoidentificacion">Tipo de identificación*</Label>
                                                    <SelectItem
                                                        options={tiposIdentificacion}
                                                        value={this.state.dtoData.tipoidentificacion}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="tipoidentificacion"
                                                        id="tipoidentificacion"
                                                        icon="fa-caret-right"
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2} sm={12} xs={12}>
                                                <FormGroup>
                                                    <Label for="numeroidentificacion">Identificación*</Label>
                                                    <Input type="text" maxLength="10" name="numeroidentificacion" id="numeroidentificacion" value={this.state.dtoData.numeroidentificacion} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>
                                            {
                                                this.state.dtoData.nombrecontacto && this.state.dtoData.nombrecontacto !== "" && 
                                                 this.state.dtoData.numeroidentificacion.length === 0 &&
                                                 
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <Label for="nombrecontacto">Nombres / Apellidos*</Label>
                                                        <Input type="text" maxLength="90" name="nombrecontacto" id="nombrecontacto" value={this.state.dtoData.nombrecontacto} required onChange={this.handleChange} />
                                                    </FormGroup>
                                                </Col>
                                            }

                                            {
                                                (this.state.dtoData.tipoidentificacion) &&
                                                ( this.state.dtoData.numeroidentificacion.length > 0 ||  !this.state.dtoData.nombrecontacto)
                                                &&
                                                <React.Fragment>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label for="nombres">Nombres*</Label>
                                                            <Input type="text" maxLength="50" name="nombres" id="nombres" value={this.state.dtoData.nombres} onChange={this.handleChange} required readOnly={this.state.dtoData.tipoidentificacion === "CED" || this.state.readOnlyDatos ? true : false} />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label for="apellidos">Apellidos*</Label>
                                                            <Input type="text" maxLength="50" name="apellidos" id="apellidos" value={this.state.dtoData.apellidos} onChange={this.handleChange} required readOnly={this.state.dtoData.tipoidentificacion === "CED" || this.state.readOnlyDatos ? true : false} />
                                                        </FormGroup>
                                                    </Col>
                                                </React.Fragment>

                                            }
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="idpais">Parentesco*</Label>
                                                    <SelectItem
                                                        options={parentescoList}
                                                        value={this.state.dtoData.idparentescocontac}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="idparentescocontac"
                                                        id="idparentescocontac"
                                                        icon="parentesco"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="idpais">País*</Label>
                                                    <SelectItem
                                                        options={paisList}
                                                        value={this.state.dtoData.idpais}
                                                        onChange={this.cargarProvincias}
                                                        placeholder=""
                                                        name="idpais"
                                                        id="pais"
                                                        icon="pais"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="idpais">Provincia*</Label>
                                                    <SelectItem
                                                        options={provinciaList}
                                                        value={this.state.dtoData.idprovincia}
                                                        onChange={this.cargarCantones}
                                                        placeholder=""
                                                        name="idprovincia"
                                                        id="provincia"
                                                        icon="ubicacion"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="idpais">Ciudad*</Label>
                                                    <SelectItem
                                                        options={ciudadList}
                                                        value={this.state.dtoData.idcanton}
                                                        placeholder=""
                                                        name="idcanton"
                                                        id="idcanton"
                                                        icon="ubicacion"
                                                        onChange={this.handleSelectChange}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={8}>
                                                <Label for="codigopais">Dirección*</Label>
                                                <FormGroup>
                                                    <InputGroup>
                                                        <Input type="text" maxLength="91" name="direccioncontacto" id="direccioncontacto" placeholder="" value={this.state.dtoData.direccioncontacto} required onChange={this.handleChange} />
                                                        <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                            <Icon kind="ubicacion" fill='#FFFFFF' width={27} height={27} />
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="codigopais">Código postal</Label>
                                                    <InputGroup>
                                                        <Input type="text" maxLength="30" value={this.state.dtoData.codigopostal} name="codigopostal" placeholder="" onChange={this.handleChange} />
                                                        <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                            <Icon kind="codigo_postal" fill='#FFFFFF' width={27} height={27} />
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md={8}>
                                                <FormGroup>
                                                    <Label for="telefonocontacto">Email</Label>
                                                    <FormGroup>
                                                        <InputGroup>
                                                            <Input type="email" maxLength="100" name="email" id="email" value={this.state.dtoData.email} onChange={this.handleChange} />
                                                            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                <Icon kind="numero" fill='#FFFFFF' width={27} height={27} />
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </FormGroup>
                                            </Col>

                                        </Row>

                                        <Row form>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="nombrecontacto">Tipo de teléfono*</Label>
                                                    <SelectItem
                                                        options={tiposTelefono}
                                                        value={this.state.dtoData.tipotelefono}
                                                        placeholder=""
                                                        name="tipotelefono"
                                                        id="tipo"
                                                        //icon="fa-phone"
                                                        icon="telefono"
                                                        onChange={this.handleSelectChangeTipo}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="codigopais">Código país*</Label>
                                                    <InputGroup>
                                                        <Input step="1" min="1" max="99" type="number" name="codigopais" id="codigopais" value={this.state.dtoData.codigopais} required onChange={(e) => this.lengthValidation(e, 2,false)} readOnly />
                                                        <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                            <Icon kind="telefono_area" fill='#FFFFFF' width={27} height={27} />
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="idpais">Código área / estado*</Label>
                                                    {
                                                        this.state.dtoData.codigopais === "593" && this.state.dtoData.tipotelefono !== "C" ?
                                                            <SelectItem
                                                                options={codigoAreaList}
                                                                value={this.state.dtoData.codigoarea}
                                                                onChange={this.handleSelectChange}
                                                                placeholder=""
                                                                name="codigoarea"
                                                                id="codigoarea"
                                                                icon="ubicacion"
                                                            />
                                                            :
                                                            <InputGroup>
                                                                <Input step="1" min="1" max="99" type="number" name="codigoarea" id="codigo_area" value={this.state.dtoData.codigoarea ? this.state.dtoData.codigoarea.trim() : ""} required onChange={(e) => this.lengthValidation(e, 3,true)} readOnly={this.state.readOnlyCodigoProvincia} />
                                                                <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                    <Icon kind="telefono_area" fill='#FFFFFF' width={27} height={27} />
                                                                </InputGroupAddon>
                                                            </InputGroup>
                                                    }
                                                </FormGroup>
                                            </Col>


                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="telefonocontacto">Número*</Label>
                                                    <FormGroup>
                                                        <InputGroup>
                                                            <Input step="1" min="1" max="99999999" type="number" name="telefonocontacto" id="telefonocontacto" value={this.state.dtoData.telefonocontacto ? this.state.dtoData.telefonocontacto.trim() : ""} required onChange={(e) => this.lengthValidation(e, 8,false)} />
                                                            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                <Icon kind="numero" fill='#FFFFFF' width={27} height={27} />
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </FormGroup>
                                            </Col>



                                        </Row>
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </form >
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>

                                        </div>
                                        :
                                        <Row id="lista">
                                            {ContactosEmergenciaDataList.map((dto, index) =>
                                                <CardContactosEmergencia
                                                    key={dto.idcontactopersona}
                                                    nombrecontacto={this.chooseNameCard(dto)}
                                                    strNombreParentesco={dto.strNombreParentesco}
                                                    strNombrePais={dto.strNombrePais}
                                                    strNombreProvincia={dto.strNombreProvincia}
                                                    strNombreCanton={dto.strNombreCanton}
                                                    direccioncontacto={dto.direccioncontacto}
                                                    codigopais={dto.codigopais}
                                                    telefonocontacto={dto.telefonocontacto}
                                                    codigoarea={dto.codigoarea}
                                                    codigopostal={dto.codigopostal}
                                                    email={dto.email}
                                                    number={(index + 1) + " / " + ContactosEmergenciaDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.idcontactopersona)}
                                                    eventDelete={() => this.onClickDelete(dto.idcontactopersona)} />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default Telefonos;